import { Platform, type FlatListProps } from 'react-native';

/** Props recomendadas para FlatList en listas operativas (POS, catálogo, inventario, etc.). */
export const VIRTUALIZED_LIST_PROPS = {
  initialNumToRender: 10,
  maxToRenderPerBatch: 10,
  windowSize: 5,
  removeClippedSubviews: Platform.OS !== 'web',
  updateCellsBatchingPeriod: 50,
} as const satisfies Partial<FlatListProps<unknown>>;
